import { render } from "./ContentAboutText.vue?vue&type=template&id=014a51e4"
import script from "./ContentAboutText.vue?vue&type=script&lang=js"
export * from "./ContentAboutText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__